'use client'
// Types
import type { ISession } from '@/types/session'
import type { ReactNode } from 'react'
// Hooks
import { createContext, useContext } from 'react'

interface ISessionProviderProps {
  session: ISession
  children: ReactNode
}

const sessionContext = createContext<ISession | undefined>(undefined)

export function SessionProvider({ children, session }: ISessionProviderProps) {
  return <sessionContext.Provider value={session}>{children}</sessionContext.Provider>
}

export const useSession = (): ISession => {
  const context = useContext(sessionContext)
  if (!context) {
    throw new Error('useSession must be used within a SessionProvider')
  }
  return context
}
